@if (previousUrl) {
  <a (click)="goback()" [title]="text" class="nav-to-links go-back">
    <mat-icon class="chevron_left">chevron_left</mat-icon>
    <span>{{ text }}</span>
  </a>
}
<a [routerLink]="altLink" [title]="altText" class="nav-to-links go-back">
  <mat-icon class="format_list_bulleted">format_list_bulleted</mat-icon>
  <span>{{ altText }}</span>
</a>
